import { Link } from "react-router-dom";
import styled from "styled-components";
import FooterSlantedSection from "./FooterSlantedSection";
import { Divider, Typography } from "@mui/material";
import { useScreenWidthRange } from "./LandingOne";

const Footer = () => {
  const isTablet = useScreenWidthRange(768, 1024);
  const isMobile = useScreenWidthRange(0, 767);

  // const FooterData = [
  //   {
  //     id: 1,
  //     title: 'SOLUTIONS',
  //     child: [
  //       { title: 'Pricing', link: '/under-maintenance' },
  //       { title: 'Carriers', link: '/under-maintenance' },
  //       { title: 'Return Shipping', link: '/under-maintenance' },
  //       { title: 'Labels', link: '/under-maintenance' },
  //       { title: 'Shipping API', link: '/under-maintenance' },
  //       { title: 'SmartRate API', link: '/under-maintenance' },
  //       { title: 'Tracking API', link: '/under-maintenance' },
  //     ]
  //   },
  //   {
  //     id: 2,
  //     title: 'DEVELOPERS',
  //     child: [
  //       { title: 'Guide', link: '/under-maintenance' },
  //       { title: 'API Docs', link: '/under-maintenance' },
  //       { title: 'Client Libraries', link: '/under-maintenance' },
  //       { title: 'Carrier Updates', link: '/under-maintenance' },
  //       { title: 'Engineer Blog', link: '/under-maintenance' },
  //       { title: 'Status', link: '/under-maintenance' },
  //     ]
  //   },
  //   {
  //     id: 3,
  //     title: 'CONTACT US',
  //     child: [
  //       { title: 'Talk to Support', link: '/under-maintenance' },
  //       { title: 'Contact Sales', link: '/under-maintenance' },
  //     ]
  //   },
  //   {
  //     id: 4,
  //     title: 'COMPANY',
  //     child: [
  //       { title: 'About Us', link: '/about-us' },
  //       { title: 'Core Modules', link: '/under-maintenance' },
  //       { title: 'Boosters', link: '/under-maintenance' },
  //     ]
  //   },
  // ];

  return (
    <>
      <footer style={{ width: "100%" }}>
        <FooterSlantedSection />

        <FooterContainer>
          <LeftContainer>
            <Link to="/">
              <Logo src="assets/img/logo.png" alt="img" />
            </Link>
          </LeftContainer>
          {/* <RightContainer>
            {
              FooterData.map((section) => (
                <LinkContainer key={section.id}>
                  <FooterTitle>{section.title}</FooterTitle>
                </LinkContainer>
              ))
            }
          </RightContainer> */}
        </FooterContainer>

        <div
          style={{
            background: "#0A2472",
            padding: isTablet || isMobile ? '0 24px 24px' : '0px 48px 24px',
            maxWidth: '100%',
            display: 'flex',
            flexDirection: 'column',
            flex: 1
          }}
        >
          <Divider
            sx={{
              backgroundColor: '#FFF',
              opacity: 0.2,
              width: '100%',
              marginBottom: '24px'
            }}
          />

          <Typography
            sx={{
              color: '#FFF',
              fontFamily: 'Switzer',
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: '400',
              lineHeight: '100%',
              marginBottom: '8px'
            }}
          >
            PT MAJURA DIGITATAL SOLUSI
          </Typography>
          <Typography
            sx={{
              color: '#ffffffa4',
              fontFamily: 'Switzer',
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: '400',
              lineHeight: '100%',
              marginBottom: '12px'
            }}
          >
            JALAN KALI BESAR BARAT AT NOMOR 50,<br /> 
            Desa/Kelurahan Roa Malaka,<br /> 
            Kec. TaTambora, Kota Adm. <br /> 
            Jakarta Barat, <br /> 
            Provinsi DKI Jakarta,<br /> 
            Kode Pos: 11230
          </Typography>



          <Typography
            sx={{
              color: '#FFF',
              fontFamily: 'Switzer',
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: '400',
              lineHeight: '100%',
            }}
          >
            © Majura Apps. All rights reserved
          </Typography>
        </div>
      </footer>
    </>
  );
};

const LeftContainer = styled.div`
  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;
    align-items: center;
  }
`;

// const RightContainer = styled.div`
//   display: flex;
//   flex-direction: row;
//   justify-content: flex-end;

//   @media (max-width: 767px) {
//     align-items: center;
//     justify-content: center;
//     padding: 12px 48px 0px;
//     flex: 1;
//   }
// `;

// const LinkContainer = styled.div`
//   flex-direction: column;
//   margin-right: 20px;
// `;

const FooterContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: space-between;
  background: #0a2472;
  padding: 56px 48px 24px;
  position: relative;;
  z-index: 2;

  @media (max-width: 767px) {
    width: 100%;
    position: relative;
    margin-top: -125.4px;
    padding: 48px 0px;
    height: max-content;
    flex-direction: column;
    z-index: 1;
  }
`;

const Logo = styled.img`
  height: auto;
  max-width: 250px;
`;

// const FooterLink = styled(Link)`
//   color: white;
//   font-size: 0.8em;
// `;

// const FooterTitle = styled.p`
//   font-size: 1em;
//   color: white;
//   font-weight: 800;
//   margin: 0;
// `;

// const BgBottom = styled.div`
//   bottom: 0;
//   left: 0;
//   width: 100%;
//   background: #0A2472;
//   // padding-top: 50px;
//   // padding-bottom: 100px;
// `;

export default Footer;
